import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { QuickOrderMain } from "../../View/QuickOrder/quickOrdSidePopup/QuickOrderMain";

export const EmptyCart = ({ showHomeButton, showQuickOrderButton = false, showQuickOrderPopuButton=false }) => {
  const { location } = useLocation();
  const history = useNavigate();

    return (
      <>
    <div className="empty-cart-container" style={{ height: "40vh" }}>
      <div className="empty-cart">
        <FontAwesomeIcon
          icon={faCartShopping}
          size="2x"
          className="cart-icon"
        />
        <h3>Your Cart is Empty</h3>
        {showHomeButton && (
          <button
            className="btn  btn-addcart"
            onClick={() => history(PAGES.HOME)}
          >
            Home
          </button>
        )}
       
              {showQuickOrderPopuButton && (<><div className="quickOrderBtn">
                  <div className="button-effect quickShopping">
                      <button type="btn" className="theme-primary" data-bs-toggle="offcanvas" data-bs-target="#quickOrder-popup" aria-controls="offcanvasRight"><span className="wes-shopping-bag"></span>Quick Order</button>
                  </div>
              </div> 
       <QuickOrderMain /></>)}
      </div>
      </div>
      </>
  );
};
